const data = {
  id: 1,
  title: 'Look and choose the correct sound.',
  subTitle: 'Nhìn hình và chọn âm xuất hiện trong từ.',
  audioUrl: '',
  imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/clock.png',

  answers: [
    { id: 1, answer: 'cr', isCorrect: false },
    { id: 2, answer: 'gl', isCorrect: false },
    { id: 3, answer: 'cl', isCorrect: true },
  ],
  settings: {
    answers: {
      direction: 'horizontal',
      bulletType: 'none',
      // bulletType: 'character',
      // bulletType: 'number',
    },
  },
};
export default data;
